export default __webpack_public_path__ + "static/media/carousel4.f4dd9470.jpg";